const nodeChalk = require("chalk")
const vibranceSetup = require("./main.js")
// use node chalk
module.exports = vibranceSetup(nodeChalk)